import {Form, message, Modal, Select} from "antd";
import {HttpService} from "../../../services/http/Http.service";
import {HttpErrorService} from "../../../services/http/HttpError.service";
import React, {useState} from "react";
import {Person, ProcessedPracticeDetail, ARCHIVE_REASON_LABELS} from "../../../model/models";
import AddressForm from "./components/AddressForm";
import CommonFormFields from "./components/CommonFormFields";
import CustomSpinner from "../../../components/spinner/CustomSpinner";

interface Props {
    onClose: () => void,
    simulatorId?: number,
    onStatusChange?: () => void,
    fetchAuditTrail: () => Promise<void>,
    person: Person,
    practice: ProcessedPracticeDetail | undefined,
    refreshDocuments?: (() => (void | undefined)) | undefined
}

export default function ArchiveModal({
                                         onClose,
                                         simulatorId,
                                         onStatusChange,
                                         fetchAuditTrail,
                                         person,
                                         practice,
                                         refreshDocuments
                                     }: Props) {
    const [uploading, setUploading] = useState(false);
    const [form] = Form.useForm();
    const [selectedArchiveLabel, setSelectedArchiveLabel] = useState<string>("");
    const [autoFillAddress, setAutoFillAddress] = useState<boolean>(false);
    const disableAddressFields = autoFillAddress;
    const archiveReasonOptions = Object.entries(ARCHIVE_REASON_LABELS)
        .filter(([value]) => value !== "IMPORTO_ANTIECONOMICO")
        .map(([value, label]) => ({value, label,}));

    const handleArchive = async () => {
        try {
            setUploading(true);
            let requestBody = {};

            if (selectedArchiveLabel === "ISTRUTTORIA_ESITO_POSITIVO") {
                const values = await form.validateFields();

                let transmittedVia
                if (values.transmissionType === "email") {
                    transmittedVia = "email: " + values.email
                } else if (values.transmissionType === "pec") {
                    transmittedVia = "PEC: " + values.email
                } else
                    transmittedVia = values.email

                requestBody = {
                    simulatorId: simulatorId,
                    personId: person?.id,
                    requestProtocolNumber: values.requestProtocolNumber,
                    requestProtocolDate: values.requestProtocolDate?.format("YYYY-MM-DD"),
                    email: transmittedVia,
                    province: values.province,
                    city: values.city,
                    cap: Number(values.cap),
                    address: values.address,
                    residenceHousenumber: values.houseNumber,
                    practiceYears: practice?.years,
                    dataArchiving: practice?.createdAt!,
                    archivingProtocol: practice?.protocolNumber!,
                    praticeType: practice?.type,
                };
            }

            await HttpService.getInstanceAxios().post(
                `/file-ts/${simulatorId}/archive/${person?.id}`,
                {
                    causal: selectedArchiveLabel,
                    ...requestBody
                }
            );

            message.success("Pratica archiviata con successo");
            onClose();
            onStatusChange?.();
            await fetchAuditTrail();
            if (refreshDocuments && selectedArchiveLabel === "ISTRUTTORIA_ESITO_POSITIVO") {
                refreshDocuments()
            }

        } catch (error) {
            HttpErrorService.handle("Errore durante l'archiviazione della pratica", error, true);
        } finally {
            setUploading(false);
        }
    };

    return (
        <>
            <Modal
                title={"Archiviazione pratica"}
                open={true}
                onOk={handleArchive}
                onCancel={onClose}
                okText="OK"
                cancelText="Annulla"
                maskClosable={false}
            >
                <p>Per quale motivo vuoi archiviare la pratica?</p>
                <Select
                    style={{width: "100%"}}
                    options={archiveReasonOptions}
                    value={selectedArchiveLabel || undefined}
                    onChange={setSelectedArchiveLabel}
                    placeholder="Seleziona motivo"
                />

                {selectedArchiveLabel === "ISTRUTTORIA_ESITO_POSITIVO" && (
                    <Form layout="vertical" form={form} style={{marginTop: 24}}>

                        <CommonFormFields fieldsToShow={["requestProtocolNumber", "requestProtocolDate", "email"]}/>

                        <AddressForm
                            autoFillAddress={autoFillAddress}
                            setAutoFillAddress={setAutoFillAddress}
                            disableAddressFields={disableAddressFields}
                            form={form}
                            personCF={person?.fiscalCode}
                        />
                    </Form>
                )}
            </Modal>
            <CustomSpinner
                message={"Generazione documento in corso..."}
                open={uploading}
            />
        </>
    );
}
